import { IonContent, IonPage } from "@ionic/react";
import { withRouter } from "react-router";
import Button from "@mui/material/Button";
import { Tooltip } from "@material-ui/core";
import Header from "src/components/Header";



const Comunicado = () => {
    const encuestas = [
        {
            id: 1,
            nombre: "INFORMACION",
            descripcion: "Encuesta sobre Información de Vivienda y Antecedentes Laborales",
            fecha_inicio: "2024-05-05",
            fecha_fin: "2024-05-12",
            url_encuesta: "https://forms.gle/W9MSx82hG6GjLLxg6"
        },
        {
            id: 2,
            nombre: "RESPONSABILIDAD SOCIAL",
            descripcion: "Encuesta 2",
            fecha_inicio: "2024-05-15",
            fecha_fin: "2024-05-21",
            url_encuesta: "XXXXXXXXXXXXXXXXXXXXXX"
        }
    ]
  return (
    <IonPage>
      <Header titulo="COMUNICADOS"/>
      <IonContent id="home">
        <div className="container mt-3">
          <div className="d-flex justify-content-center">
            <figure>
              <blockquote>
                <p>POR FAVOR REALIZAR ENCUESTA OBLIGATORIA</p>
              </blockquote>
              <figcaption>
                <cite>
                  
                 {encuestas.map((encuesta) => (
                
                <Button
                variant="contained"
                color="error"
                href={encuesta.url_encuesta}
                style={{
                  color: "white",
                  width: "100%",
                  marginTop: 10,
                  height: "auto", // Ajusta automáticamente la altura según el contenido
                  minHeight: "64px", // Establece una altura mínima para el botón
                }}
              >
                
                {<Tooltip title={encuesta.descripcion}>
                  <span>
                    {encuesta.nombre}
                  </span>
                </Tooltip>}
              </Button>
              
                ))}
                </cite>
              </figcaption>
            </figure>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(Comunicado);
